export const frontend_skills = [
  {
    id: 1,
    skillName: "HTML5",
    level: "Intermediate",
  },
  {
    id: 2,
    skillName: "CSS3",
    level: "Intermediate",
  },
  {
    id: 3,
    skillName: "Bootstrap",
    level: "Intermediate",
  },
  {
    id: 4,
    skillName: "Advanced JavaScript",
    level: "Experienced",
  },
  {
    id: 5,
    skillName: "ReactJs",
    level: "Experienced",
  },
  {
    id: 6,
    skillName: "EtherJs",
    level: "Intermediate",
  },
  {
    id: 7,
    skillName: "WEB3Js",
    level: "Intermediate",
  },
  {
    id: 8,
    skillName: "Moralis",
    level: "Intermediate",
  },
];

export const backend_skills = [
  {
    id: 1,
    skillName: "Node.js",
    level: "Experienced",
  },
  {
    id: 2,
    skillName: "ExpressJS",
    level: "Experienced",
  },
  {
    id: 3,
    skillName: "MySQL",
    level: "Experienced",
  },
  {
    id: 4,
    skillName: "Solidity",
    level: "Intermediate",
  },
  {
    id: 5, 
    skillName: 'Ethereum',
    level: 'Intermediate'
  },
  {
    id: 6, 
    skillName: 'C Programming',
    level: 'Intermediate'
  },
  {
    id: 7, 
    skillName: 'Algorithms',
    level: 'Intermediate'
  },
  {
    id: 8, 
    skillName: 'Data Structures',
    level: 'Intermediate'
  },
];